var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "location-info" },
    [
      _c(
        "span",
        {
          staticClass: "material-icons location-info-item vehicle",
          style: { color: _vm.getIconColour() },
        },
        [_vm._v("\n        " + _vm._s(_vm.getIcon()) + "\n    ")]
      ),
      _c(
        "md-icon",
        { staticClass: "footer-icon user-pin location-info-item" },
        [_vm._v("push_pin")]
      ),
      _vm.data == null
        ? _c("p", { staticClass: "location-info-item" }, [
            _vm._v("No location update ever received"),
          ])
        : _vm.data.lastLocationUpdate
        ? _c(
            "p",
            {
              staticClass: "location-info-item",
              class:
                _vm.$_getLastLocationUpdateIndicatorColor(_vm.convertedDate) +
                "-indicator " +
                _vm.customClass,
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("dateFormat")(
                      _vm.convertedDate,
                      _vm.dateTypes.standardDateTime
                    )
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }